import { Injectable } from '@angular/core';
import type { SegmentedDateInputYearOrder } from './segmented-date-input.types';

/**
 * Passes `yearOrder` to the calendar header. Material builds the header
 * itself from a class reference (no template, no `@Input`), so DI is the
 * only way in.
 */
@Injectable()
export class SegmentedDateInputYearOrderSource {
  yearOrder: SegmentedDateInputYearOrder = 'descending';
}
